import React from "react";
import PublicRoutes from "./routes/index";
import SessionWarning from "./components/common/SessionWarning/SessionWarning";
import { AuthProvider } from "./contexts/AuthContext";
import "./App.css";

const App = () => (
  <AuthProvider>
    <SessionWarning />
    <PublicRoutes />
  </AuthProvider>
);

export default App;
